<!-- Footer -->
<div
    class="bg-card relative z-49 flex h-14 w-full flex-0 items-center justify-start border-t px-4 dark:bg-transparent md:px-6 print:hidden"
>
    <span class="text-secondary font-medium"
        >{{ name }} &copy; {{ currentYear }} v{{ version }}</span
    >
</div>
